const _1_MW = 1000000
const _1_KW = 1000
const KW_PER_MW = 1000

export function convertFromWToMW(volume: number | null | undefined) {
  if (!volume) return 0
  return volume / _1_MW
}

// Rounded to whole kW and always shown with 3 decimals, so small live changes stay visible
export function convertFromWToRoundedMW(measurement: number) {
  const roundedKW = Math.sign(measurement) * Math.round(Math.abs(measurement) / _1_KW)
  return (roundedKW / KW_PER_MW).toFixed(3)
}
